/** アバター未設定時に表示する画像
 * 環境ごとに REACT_APP_DEFAULT_AVATAR_URL で上書き可能 */
export const DEFAULT_AVATAR_URL =
  process.env.REACT_APP_DEFAULT_AVATAR_URL || '';

/**
 * 職員の avatar_url が空のときは DEFAULT_AVATAR_URL を返す（それも空なら undefined で頭文字表示）
 */
export function resolveStaffAvatarSrc(avatarUrl: string | null | undefined): string | undefined {
  const u = typeof avatarUrl === 'string' ? avatarUrl.trim() : '';
  if (u) return u;
  const d = DEFAULT_AVATAR_URL.trim();
  return d || undefined;
}
